
import axios from 'axios';
import {SET_VARIABLES_IN_EDITOR} from "actions/EditorActions";

export const SOCKET_CONNECT_NOTIFICATIONS = 'SOCKET_CONNECT_NOTIFICATIONS';
export const SOCKET_CONNECTED_NOTIFICATIONS = 'SOCKET_CONNECTED_NOTIFICATIONS';
export const SOCKET_DISCONNECTED_NOTIFICATIONS = 'SOCKET_DISCONNECTED_NOTIFICATIONS';
export const SOCKET_EVENT_NOTIFICATIONS = 'SOCKET_EVENT_NOTIFICATIONS';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_READ = 'SET_READ';
export const GET_USER_NOTIFICATIONS = 'GET_USER_NOTIFICATIONS';
export const CHANGE_STATUS = 'CHANGE_STATUS';
export const GET_FILE_VIA_NOTIFICATION = 'GET_FILE_VIA_NOTIFICATION';

/** initial connection to socket */
export const socketConnectNotifications = (options = {}) => ({
  type: SOCKET_CONNECT_NOTIFICATIONS,
  payload: options,
});

/** confirm connection to socket */
export const socketConnectedNotifications = () => ({
  type: SOCKET_CONNECTED_NOTIFICATIONS,
});

/** disconnect socket connection */
export const socketDisconnectedNotifications = () => ({
  type: SOCKET_DISCONNECTED_NOTIFICATIONS,
});

/** realtime notifications from socket */
export const socketEventNotifications = (event) => {
  return {
    type: SOCKET_EVENT_NOTIFICATIONS,
    payload: { event },
  }
};

/** initial notifications from database */
export const getAllNotificationsR = (options = {}) => {
  const {
    clientId,
    showAll = false,
    offset = 0,
    limit = 100
  } = options;

  return {
    type: GET_NOTIFICATIONS,
    payload: axios.get('/api/notification.json', {
      params: {
        ...(clientId && { clientId: clientId }),
        showAll: showAll,
        offset: offset,
        limit: limit
      }
    }).then(({ data }) => data),
  };
};

/** set notification as read */
export const setAsReadR = (notificationId) => {
  return {
    type: SET_READ,
    payload: axios.post('/api/readnotifications/' + notificationId + '.json').then(({ data }) => data),
  };
};


export const changeStatusR = (key) => {
  return {
    type: CHANGE_STATUS,
    payload: key,
  };
}

export function getFileViaNotificationR(messages, uploads, fileType) {
  const payloadData = [];
  payloadData.messages = messages;
  payloadData.files = uploads;
  payloadData.fileType = fileType
  return {
    type: GET_FILE_VIA_NOTIFICATION,
    payload: payloadData,
  };
}
